'use strict'

require '../core/grpn-lazyload'

module.exports = Groupon.Utils.lazyLoadImages = (options, triggerClass = '.lazy-load') ->
  if ($el = $(triggerClass)).length
    $el.lazyload(options)
  return



// WEBPACK FOOTER //
// ./src/frontend/helper/lazyLoadImages.coffee